import Card from "components/card/card";
import DailyStats from "components/dashboard/daily-stats";
import TopInteractions from "components/dashboard/top-interactions";
import TopPopouts from "components/dashboard/top-popouts";
import TotalStats from "components/dashboard/total-stats";
import { FilterSelector } from "components/global/filterSelector";
import Select from "components/select/select";
import { Context } from "context/context";
import _ from "lodash";
import moment from "moment";
import { Fragment, useContext, useEffect, useMemo, useState } from "react";
import { useTabs } from "react-headless-tabs";
import { useParams } from "react-router-dom";
import { getMonths, getWeeks } from "utils/constant";

const filters = [
  { label: "Weekly", value: "weekly" },
  { label: "Monthly", value: "monthly" },
];

export default function CampaignStatistics() {
  const { id } = useParams();
  const { campaign } = useContext(Context);
  const [filter, setFilter] = useTabs(["weekly", "monthly"]);
  const [filterValue, setFilterValue] = useState("");
  const [dateOptions, setDateOptions] = useState([]);
  const [filterDates, setFilterDates] = useState({
    start: moment().unix(),
    end: moment().unix(),
  });
  const reportParams = useMemo(() => {
    return {
      campaign_id: id,
    };
  }, [id]);

  useEffect(() => {
    let options = [];
    if (filter === "weekly") {
      options = getWeeks(campaign?.created_at);
      setDateOptions(options);
      setFilterValue(options[0].value);
      setFilterDates({
        start: options[0].dates.start,
        end: options[0].dates.end,
      });
    } else {
      options = getMonths(campaign?.created_at);
      setDateOptions(options);
      setFilterValue(options[0].value);
      setFilterDates({
        start: options[0].dates.start,
        end: options[0].dates.end,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, campaign]);

  return (
    <Fragment>
      {/* Statistics */}
      <div className="w-full h-full mb-3 bg-white border rounded-sm border-thBorder">
        {/* header */}
        <div className="px-6 w-full flex flex-wrap items-center">
          <div className="w-1/2 inline-flex items-center py-5 2md:w-3/12">
            <h1 className="mr-5 text-2xl">Statistics Overview</h1>
          </div>
          <div className="w-1/2 2md:w-9/12">
            <div className="inline-flex items-center float-right space-x-5">
              <nav className="2md:bg-lightDarkGray 2md:rounded-full 2md:py-1 2md:px-1 relative">
                {filters.map((obj, index) => {
                  return (
                    <FilterSelector
                      key={`filters-${index}`}
                      isActive={filter === obj.value}
                      onClick={() => setFilter(obj.value)}
                    >
                      {obj.label}
                    </FilterSelector>
                  );
                })}
              </nav>
              <div className="w-72">
                <Select
                  placeholder="Filter"
                  value={_.find(dateOptions, ["value", filterValue])?.label}
                  options={dateOptions}
                  onChange={({ value, dates }) => {
                    setFilterValue(value);
                    setFilterDates({
                      start: dates.start,
                      end: dates.end,
                    });
                  }}
                  readOnly={true}
                />
              </div>
            </div>
          </div>
        </div>
        {/* header */}
      </div>
      <div className="w-full px-px my-px overflow-hidden">
        <TotalStats
          start={filterDates.start}
          end={filterDates.end}
          params={reportParams}
          dateLabel={_.find(dateOptions, ["value", filterValue])?.label}
        />
      </div>
      {/* Device Environment & Top Performing Popouts (Form Submissions) */}
      <Card padding="" className="w-full border border-thBorder mb-2" height="">
        <div className="w-full grid 5md:grid-cols-2 divide-y 5md:divide-x 5md:divide-y-0 divide-thBorder">
          <div className="p-8">
            <TopInteractions
              start={filterDates.start}
              end={filterDates.end}
              params={reportParams}
            />
          </div>
          <div className="p-8">
            <TopPopouts
              start={filterDates.start}
              end={filterDates.end}
              params={reportParams}
            />
          </div>
        </div>
      </Card>
      {/* end: Device Environment & Top Performing Popouts (Form Submissions) */}
      <div className="w-full">
        <DailyStats
          start={filterDates.start}
          end={filterDates.end}
          params={reportParams}
        />
      </div>
    </Fragment>
  );
}
